import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AssetAudit} from '../../domain/item';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummaryAssetAuditService {

  public assetAuditInformationServiceCallback: Subject<AssetAudit[]> = new Subject<AssetAudit[]>();

  protected constructor() {
  }

  abstract getAssetAuditInformation(assetId: number): Observable<any>;

}
